import store from '../../src/utils/store'

// 秒数转时间格式
function secondToTime(item) {
  if (typeof item != 'number' || isNaN(item)) {
    return '00:00';
  }
  var s = item % 60 < 10 ? '0' + item % 60 : (item % 60).toString();
  item = parseInt(item / 60);
  if (item == 0) {
    return '00:' + s;
  }
  var m = item < 10 ? '0' + item : item.toString();
  return m + ":" + s;
}

// 手机号校验
const checkPhone = (value) => {
  var reg = /^((13[0-9])|(14[5,7,9])|(15([0-3]|[5-9]))|(166)|(17[0,1,3,5,6,7,8,9])|(18[0-9])|(19[8|9]))\d{8}$/
  if (reg.test(value)) {
    return true;
  } else {
    return false;
  }
};

// 判断数字
const checkNumber = (item) => {
  if (!item) {
    return ''
  }
  var reg = /^[0-9]$/
  if (reg.test(item.charAt(item.length - 1))) {
    return item;
  } else {
    return item.slice(0, item.length - 1)
  }
};

// 判断是否为移动端浏览器
const isMobile = () => {
  var ua = navigator.userAgent;
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    isMobile = isIphone || isAndroid || ipad;
  //判断
  if (isMobile) {
    return true;
  } else {
    return false;
  }
}

// 判断是否为微信浏览器
const isWX = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

// 随机字符串
function randomString(length) {
  var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

// 设置微信分享
function setWXShare(item) {
  if (isWX() && wx) {
    var link = window.location.href.split('#/')[0] + '#/';
    var acceptPath = ['/NiuCeLue', '/NiuRenKe', '/NiuRenKe/video', '/singleVideo', '/NiuRenKe/audio',
      '/singleAudio', '/liveDetail', '/repeatDetail'
    ];
    var schema = 'http://';
    if (link.indexOf('https') != -1) {
      schema = 'https://';
    }
    for (var i in acceptPath) {
      if (window.location.href.split('#')[1].split('?')[0] == acceptPath[i]) {
        link = schema + window.location.host + '/#' + window.location.href.split('#')[1];
      }
    }

    link = link.replace('?from=singlemessage', '');

    wx.ready(() => { //需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({
        title: '斗牛财经', // 分享标题
        desc: item.title, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: item.imgUrl, // 分享图标
        success: function () {
          console.log("分享成功")
        }
      })
    });
  }
}

// 签名
function sign(timestamp, type, phone) {
  var str = "timestamp=" + timestamp + "&type=" + type + "&ubPhone=" + phone + "&key=" + store.state.signKey;
  return str;
}
//cst时间格式化
function cstDateFormat (date, format) {
    date = new Date(date);
    date.setHours(date.getHours()-14);
    var o = {
        'M+' : date.getMonth() + 1, //month
        'd+' : date.getDate(), //day
        'H+' : date.getHours(), //hour
        'm+' : date.getMinutes(), //minute
        's+' : date.getSeconds(), //second
        'q+' : Math.floor((date.getMonth() + 3) / 3), //quarter
        'S' : date.getMilliseconds() //millisecond
    };

    if (/(y+)/.test(format))
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));

    for (var k in o)
        if (new RegExp('(' + k + ')').test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));

    return format;
}

function liveCommentTimeHandle(timestamp){
	var diffTime = ((new Date()).getTime() - timestamp) / 1000;
	var lvrrDiffTime = '刚刚';
	if (diffTime < 300) {
	    //s
	    lvrrDiffTime = "刚刚";
	} else if (300 <= diffTime && diffTime < 3600) {
	    //h
	    lvrrDiffTime = parseInt(Math.floor(diffTime / 60)) + "分钟前";
	} else if (3600 <= diffTime && diffTime < 86400) {
	    //h
	    lvrrDiffTime = parseInt(Math.floor(diffTime / 3600)) + "小时前";
	} else if (86400 <= diffTime && diffTime < 345600) {
	    //d
	    lvrrDiffTime = parseInt(Math.floor(diffTime / 86400)) + "天前";
	} else{
		lvrrDiffTime = (new Date(timestamp)).toLocaleDateString();
	}
	
	return lvrrDiffTime;
}

//进入全屏
function FullScreen() {
    var ele = document.documentElement;
    if (ele.requestFullscreen) {
        ele.requestFullscreen();
    } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
    } else if (ele.webkitRequestFullScreen) {
        ele.webkitRequestFullScreen();
    }
}
//退出全屏
function exitFullscreen() {
    var de = document;
    if (de.exitFullscreen) {
        de.exitFullscreen();
    } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen();
    } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen();
    }
}
//清除特殊符号
function stringTrim(value){
	var pattern=/[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
	return value.replace(pattern,"");
}

//数组对象去重
function arrUnique(Arr,child){
	const mapObj = new Map();
	// Arr.filter(item => !mapObj.has(item.id) && mapObj.set(item.id,1));
	if(!child) return false;
	var res = Arr.some(item => {
		if(item.id === child.id && item.comment === child.comment) return true;
	});
	
	if(res){
		return true;
	}else{
		return false;
	}
}

export default {
  secondToTime,
  checkPhone,
  checkNumber,
  isMobile,
  isWX,
  randomString,
  setWXShare,
  sign,
  cstDateFormat,
  liveCommentTimeHandle,
  FullScreen,
  exitFullscreen,
  stringTrim,
  arrUnique
}


//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 